import { Button, Link } from '@tmov/design-system';
import { Modal, Row as RowAntd } from 'antd';
import styled, { css } from 'styled-components';

import colors from '../../../../../../../styles/colors';

export const Container = styled.button`
  position: relative;
  background: none;
  border: none;
  cursor: pointer;

  display: flex;
  flex-direction: row;
  align-items: center;

  ${props =>
    props.disabled &&
    css`
      cursor: default;
    `}

  svg {
    color: rgba(0, 0, 0, 0.25);
    margin-left: 7px;
    font-size: 16px;
  }
`;

export const Tag = styled.div`
  width: 90px;
  color: ${props => props.textColor};
  background-color: ${props => props.backgroundColor};

  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  border-radius: 13px;
  border: 1px solid ${props => props.textColor};

  ${props =>
    props.disabled &&
    css`
      color: #36262675;
      border-color: #36262675;
      background-color: #aaaaaa3b;
    `}
`;

export const Options = styled.ul`
  position: absolute;
  width: 100%;
  top: 30px;
  right: 11.75px;
  z-index: 999;

  list-style-type: none;
  margin: 0;
  padding: 0;

  border: 1px solid #d7dde0;
  background-color: #fff;
`;

export const Option = styled.li`
  padding: 5px;

  display: flex;
  justify-content: center;

  &:hover {
    background-color: #f5f5f5;
  }

  ${props =>
    props.disabled &&
    css`
      background-color: #aaaaaa3b;

      &:hover {
        background-color: #aaaaaa3b;
      }
    `}
`;

export const CustomModal = styled(Modal)`
  width: 464px !important;
  height: 426px !important;
  display: flex;
  flex-direction: column;

  .ant-modal-body {
    margin: 8px 4px;
  }

  .ant-modal-footer {
    display: flex;
    justify-content: flex-end;
    border: none;
    margin-right: 20px;
    margin-bottom: 20px;
  }
`;

export const ModalContent = styled.div`
  margin-top: 8px;
`;

export const ModalInfo = styled.p`
  font-family: 'Inter';
  font-style: normal;
  font-weight: ${props => (props.regular ? 400 : 600)};
  font-size: ${props => (props.regular ? '14px' : '16px')};
  line-height: 150%;
  color: ${props =>
    props.regular ? colors.$greyscale_dark_grey_10 : colors.$greyscale_black_5};
`;

export const ModalTitle = styled.div`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 130%;

  display: flex;
  flex-direction: row;
  align-items: center;

  color: ${colors.$brandcolor_primary_blue};
  margin-bottom: 32px;
`;

export const ButtonPrimary = styled(Button)`
  font-family: 'Inter' !important;
  padding: 8px 24px;
  width: 105px;
  height: 36px;
`;

export const ButtonCancel = styled(Link)`
  font-family: 'Inter' !important;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 150%;
  padding: 8px 24px;
`;

export const RowModalContent = styled(RowAntd)`
  padding: 0 24px;
  display: flex;
  flex-flow: nowrap;
  width: 100%;
`;
